import {FC, useMemo} from 'react';

import {NavigationTab, NavigationTabs} from '@mavismart_frontend/components/navigation_tabs';
import {FEATURE_FLAGS} from '@mavismart_frontend/lib/feature_flags';
import {Door3d} from '@mavismart_frontend/pages/tabs/door_3d';
import {DoorDetails} from '@mavismart_frontend/pages/tabs/door_details';
import {DoorInfo} from '@mavismart_frontend/pages/tabs/door_info';
import {DoorMessages} from '@mavismart_frontend/pages/tabs/door_messages';
import {DoorStatistics} from '@mavismart_frontend/pages/tabs/door_statistics';
import {useAccount} from '@mavismart_frontend/stores/account_store';

interface DoorTabsProps {
  doorId: string;
  baseUrl: string;
}

export const DoorTabs: FC<DoorTabsProps> = props => {
  const {doorId, baseUrl} = props;
  const account = useAccount();
  const supportAppEnabled = account?.hasSupportApp === true && account?.supportAppEnabled === true;

  const tabs = useMemo(() => {
    const list: NavigationTab[] = [
      {
        path: `${baseUrl}/info`,
        label: 'info',
        view: <DoorInfo doorId={doorId} baseUrl={baseUrl} />,
        default: true,
      },
      {
        path: `${baseUrl}/statistics`,
        label: 'statistics',
        view: <DoorStatistics doorId={doorId} />,
      },
      {
        path: `${baseUrl}/messages`,
        label: 'messages',
        view: <DoorMessages baseUrl={`${baseUrl}/messages`} doorId={doorId} />,
      },
      {
        path: `${baseUrl}/details`,
        label: 'details',
        view: <DoorDetails baseUrl={`${baseUrl}/details`} doorId={doorId} />,
      },
    ];
    if (FEATURE_FLAGS.DOOR_3D_VIEWER_ENABLED && supportAppEnabled) {
      list.push({
        path: `${baseUrl}/3d`,
        label: 'door_3d__tab',
        // Only the active tab is rendered, so neither the model URL request nor the GLB download
        // happens until the user opens this tab.
        view: <Door3d doorId={doorId} />,
        // The canvas manages its own insets; the default tab padding would waste space.
        noPadding: true,
      });
    }
    return list as [NavigationTab, ...NavigationTab[]];
  }, [baseUrl, doorId, supportAppEnabled]);

  return <NavigationTabs tabs={tabs} />;
};

DoorTabs.displayName = 'DoorTabs';
